const AboutModule = {
  namespaced: true,
  state: {
    logos: [
      { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/about-us/logos/Agoda_logo.png` },
      { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/about-us/logos/airbnb.png` },
      { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/about-us/logos/booking-com.png` },
      { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/about-us/logos/Expedia.png` },
      { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/about-us/logos/hotels_logo_31012018.png` },
      { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/about-us/logos/ostrovok-logo.jpg` },
      { url: `${process.env.VUE_APP_ASSETS_BASE_URL}/images/about-us/logos/trip.png` }
    ]
  },
  mutations: {},
  actions: {},
  getters: {}
}

export default AboutModule
